/** Fresh fetch on every drawer open; do not retain list responses in the query cache. */
export const PLANNING_LIST_QUERY_OPTIONS = {
  staleTime: 0,
  cacheTime: 0,
  refetchOnMount: "always" as const,
  refetchOnWindowFocus: false,
};
